<template>
    <div class="body">
        <p  class="p1" style="padding-top: 8vh;">🧭 青春正当时，勿负好时光</p>
        <p class="p5">你已形成自己的学习节奏，</p>
        <p class="p6">在合适的方式中稳步前行。</p>
        <p class="p7" v-if='ReportData.deviceLab'>🖥️ 你常通过 <a class="highlight">{{ ReportData.deviceLab  }}</a> 登录富学宝典</p>
        <p class="p7" v-if='ReportData.time && ReportData.time!=0'>⏰ <a class="highlight">{{ ReportData.time }}:00</a>，是你最常开启学习的时间</p>
        <p class="p7" v-if='ReportData.monP'>📅 <a class="highlight">&nbsp;{{ ReportData.monP }}</a> 月，是你今年学习最投入的月份</p>
        <div v-show="ReportData.monPlayTable" class="chart" ref="chart" style="height: 30vh;"></div>
        <p class="p7">🧭 你已经形成了稳定而高效的学习节奏</p>
    </div>
</template>
  
<script>
import * as echarts from 'echarts';
export default {
    props: [ "ReportData"],
    data() {
        return {

        }
    },
    mounted(){
        this.initChart();
    },
    methods:{
        initChart() {
            const chartDom = this.$refs.chart;
            if (!chartDom) return;

            // 1️⃣ 处理图表实例（防止重复 init）
            if (this.myChart) {
                this.myChart.dispose();
            }
            this.myChart = echarts.init(chartDom);

            // 2️⃣ monPlayTable 为空
            if (!this.ReportData.monPlayTable) {
                this.showEmptyChart();
                return;
            }

            let jsonArray = [];
            try {
                const parsed = JSON.parse(this.ReportData.monPlayTable);
                if (Array.isArray(parsed)) {
                jsonArray = parsed;
                }
            } catch (e) {
                console.error('monPlayTable JSON 解析失败', e);
                this.showEmptyChart();
                return;
            }

            // 3️⃣ 没有有效数据
            if (!jsonArray.length) {
                this.showEmptyChart();
                return;
            }

            // 4️⃣ 构建 option
            const option = {
                xAxis: {
                    type: 'category',
                    data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
                    axisLabel: {
                        interval: 0,
                        color: '#fff'
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ffffff'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisTick: { show: false },
                    splitLine: { show: false },
                    axisLine: {
                        lineStyle: {
                        color: '#ffffff'
                        }
                    },
                    axisLabel: {
                        color: '#fff'
                    }
                },
                series: [
                {
                    name: '学习天数',
                    type: 'bar',
                    data: jsonArray.map(item => item.playtime || 0),
                    barWidth: 8,
                    itemStyle: {
                        color: '#fff',
                        borderColor: '#ada9a9'
                    }
                }
                ]
            };

            this.myChart.setOption(option);
        },
        showEmptyChart() {
            if (!this.myChart) return;
            this.myChart.setOption({
                title: {
                text: '暂无数据',
                left: 'center',
                top: 'center',
                textStyle: {
                    color: '#999',
                    fontSize: 14
                }
                },
                xAxis: { show: false },
                yAxis: { show: false },
                series: []
            });
        }
    }
}
</script>

<style scoped>
.body {
    background: url("../../assets/25October/logo.png") right  top  no-repeat,
                /* url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat, */
                url("../../assets/25Year/bg1.jpg")  no-repeat;
    background-size:100% 100%,cover;
    width: 100%;
    height: 100vh;
}
.p1,.p2, .p3, .p4 {
    width: 88%;
    margin: 0 auto;
    text-align: left;
    font-size: 18px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
  .highlight {
    font-size: 30px;
    color: purple;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
 
  .p5, .p6, .p7, .p8{
    width: 88%;
    margin: 0 auto;
    text-align: left;
    font-size: 16px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }

  .p5, .p7{
    margin-top: 20px;
  }
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25Year/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .p1,.p2, .p3, .p4 {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    font-size: 25px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .highlight {
    font-size: 30px;
    color: purple;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
 
  .p5, .p6, .p7, .p8{
    margin:0 auto;
    text-align: center;
    font-size: 20px;
    width: 92%;
  }

  .p5, .p7{
    margin-top: 20px;
  }
  .chart{
    width: 50%;
    text-align: center;
    margin: 0 auto;
  }
}
</style>